import React, { ReactNode, useContext, useEffect, useState } from 'react';

import NetworkContext from '@totem/components/portfolio/buildings/network/NetworkContext';
import { NetworkDiagram } from '@totem/components/portfolio/buildings/network/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { BUILDINGS_ENDPOINT } from '@totem/utilities/endpoints';

type Props = {
  buildingId: string;
  children?: ReactNode;
};

const NetworkContainer = ({ buildingId, children }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [data, setData] = useState<NetworkDiagram | null>(null);
  const [refreshData, setRefreshData] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [selectedNodeId, setSelectedNodeId] = useState<string | null>(null);
  const [selectedNetworkId, setSelectedNetworkId] = useState<string | null>(
    null,
  );

  useEffect(() => {
    if (refreshData) {
      setRefreshData(false);

      setIsLoading(true);

      fetch(`${BUILDINGS_ENDPOINT}/${buildingId}/network`, {
        method: 'GET',
        headers: new Headers({
          Authorization: `Bearer ${getApiToken()}`,
        }),
      })
        .then((res) => res.json())
        .then((result: NetworkDiagram) => {
          setData(result);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [refreshData, buildingId, getApiToken]);

  return (
    <NetworkContext.Provider
      value={{
        data,
        isLoading,
        selectedNodeId,
        selectedNetworkId,
        setSelectedNodeId,
        setSelectedNetworkId,
        requestRefresh: () => setRefreshData(true),
      }}
    >
      {children}
    </NetworkContext.Provider>
  );
};

export default NetworkContainer;
